/**
 * This file is built with webpack. See README.md for more information.
 */
import { makeKey as makeLocalStorageKey } from "../../speedcurve-components/src/lib/local-storage";
import startConcurrentPool from "./utils/concurrency";
import { appendOrdinal } from "./utils/numbers";

performance.mark("dashboardjs before");

function reportFunctionUsage(functionName) {
    if (window.Sentry && window.location.hostname === "staging.speedcurve.com") {
        window.Sentry.captureMessage(`Legacy function in dashboard.js was called: ${functionName}`);
    }
}

window.startConcurrentPool = startConcurrentPool;
window.appendOrdinal = appendOrdinal;

// Note we import "highcharts/highcharts.src" here. This is because we mark "highcharts"
// as an external (window.Highcharts) in webpack so that other bundles don't import
// the entire Highcharts library again. To work around the external in this particular
// bundle, we need to import a specific file from the highcharts module.
const Highcharts = (window.Highcharts = require("highcharts/highcharts.src"));

require("highcharts/modules/accessibility");
require("highcharts/modules/no-data-to-display");
require("highcharts/modules/exporting");
require("highcharts/modules/offline-exporting");
require("highcharts/modules/export-data");
require("highcharts-regression")(Highcharts);

require("./vendor/jquery.jscrollpane");
require("./vendor/jquery.mousewheel");
require("./vendor/jquery.cookie");
require("./vendor/bootstrap-datepicker-1.9.0");
require("./vendor/jquery.dateFormat");
require("./vendor/select2-4.0.12");
require("./vendor/bootstrap-toggle");

window.copyToClipboard = function copyToClipboard(element) {
    reportFunctionUsage("copyToClipboard");
    var $temp = $("<input>");
    $("body").append($temp);
    $temp.val($(element).text()).select();
    document.execCommand("copy");
    $temp.remove();
};

// check if local storage is avalible
window.has_ls = lsTest();

// FILMSTRIPS
function onFilmstrip() {
    reportFunctionUsage("onFilmstrip");
    window.filmstrip_scrollpane.reinitialise();
    $("#filmstrip-loading").remove();
    $(".scroll-pane")
        .height(window.filmstrip_scrollpane.getContentHeight() + 30 + filmstrip_reload)
        .fadeTo(200, 1, function () {
            // need to reinitialise again after the height has been set
            window.filmstrip_scrollpane.reinitialise();
            if (filmstrip_reload === 0) {
                filmstrip_reload = 1;
            } else {
                filmstrip_reload = 0;
            }
        });

    $(".filmstrip__img").click(function () {
        if (window.filmstrip_share === "") {
            window.location = window.accountUrl + "/test/" + $(this).data("test") + "/";
        } else {
            window.location = window.accountUrl + "/test/" + $(this).data("test") + "/?share=" + window.filmstrip_share;
        }
    });

    $(".scroll-pane")
        .bind("jsp-scroll-x", function (event, scrollPositionX) {
            $(".filmstrip__label").css("margin-left", scrollPositionX - 3 + "px");
        })
        .jScrollPane();
}

// check if we have a filmstrip to setup
if (document.getElementById("filmstrip")) {
    window.filmstrip_scrollpane = null;
    window.filmstrip_render = 0;
    window.filmstrip_tests = ""; // will be updated by inline JS on each dashboard
    window.filmstrip_sitename = ""; // optional, will be updated by inline JS on each dashboard
    window.filmstrip_sitecolor = ""; // optional, will be updated by inline JS on each dashboard
    window.filmstrip_frame_hightlight = ""; // optional, will be updated by inline JS on each dashboard. time values for the current selected metric. add boarder around the corresponding frame
    window.filmstrip_frame_hightlight_metric_name = ""; // optional, will be updated by inline JS on each dashboard. name of the metric used to highlight a frame
    window.filmstrip_wpt = "https://wpt.speedcurve.com/"; // will be updated by inline JS on each dashboard so the WPT server comes from common/settings.ini but we also provide a default here
    window.filmstrip_account_url = ""; //will be updated with url snippets for account
    window.filmstrip_share = ""; //will be updated with share key for account

    window.getFilmstrip = function getFilmstrip() {
        $("#filmstrip").show();
        $(".scroll-pane").fadeTo(200, 0.4);
        if (window.filmstrip_scrollpane !== null) {
            window.filmstrip_scrollpane
                .getContentPane()
                .load(
                    window.filmstrip_wpt +
                        "video/filmstrip-speedcurve.php?tests=" +
                        window.filmstrip_tests +
                        "&ival=" +
                        window.filmstripInterval +
                        "&thumbSize=" +
                        window.filmstripSize +
                        "&sitename=" +
                        window.filmstrip_sitename +
                        "&sitecolor=" +
                        window.filmstrip_sitecolor +
                        "&highlight=" +
                        window.filmstrip_frame_hightlight +
                        "&highlight_metric=" +
                        window.filmstrip_frame_hightlight_metric_name +
                        "&end=visual",
                    onFilmstrip,
                );
        }
    };

    $("#filmstrip-settings, #filmstrip-settings-done").click(function () {
        $("#filmstrip-options").slideToggle(200);
    });

    window.filmstripInterval = 500;
    if (window.has_ls === true) {
        if (null !== localStorage.getItem("filmstripInterval")) {
            window.filmstripInterval = localStorage.getItem("filmstripInterval");
        }
    }

    $("#filmstrip-interval-" + window.filmstripInterval).prop("checked", true);

    $(".filmstrip-interval").on("click", function () {
        window.filmstripInterval = $(".filmstrip-interval:checked").val();
        if (window.has_ls === true) {
            localStorage.setItem("filmstripInterval", window.filmstripInterval);
        }
        window.getFilmstrip();
    });

    window.filmstripSize = 200;
    if (window.has_ls === true) {
        if (null !== localStorage.getItem("filmstripSize")) {
            window.filmstripSize = localStorage.getItem("filmstripSize");
        }
    }

    $("#filmstrip-size-" + window.filmstripSize).prop("checked", true);

    $(".filmstrip-size").on("click", function () {
        window.filmstripSize = $(".filmstrip-size:checked").val();
        if (window.has_ls === true) {
            localStorage.setItem("filmstripSize", window.filmstripSize);
        }
        window.getFilmstrip();
    });

    // setup jquery.jscrollpane.js
    window.filmstrip_scrollpane = $(".scroll-pane")
        .jScrollPane({ showArrows: false, maintainPosition: true, autoReinitialise: true })
        .data("jsp");
    var filmstrip_reload = 0;

    // filmstrip inside a display:grid need a resize function to update the width correctly
    var filmstrip_throttle;
    $(window).bind("resize", function () {
        if (!filmstrip_throttle) {
            filmstrip_throttle = setTimeout(function () {
                window.filmstrip_scrollpane.reinitialise();
                filmstrip_throttle = null;
            }, 25);
        }
    });

    $("#filmstrip-video").click(function () {
        window.location.href = window.filmstrip_account_url + "/video/?tests=" + window.filmstrip_tests;
    });

    $("#filmstrip-image").click(function () {
        window.location.href =
            window.filmstrip_wpt +
            "video/filmstrip.php?tests=" +
            window.filmstrip_tests +
            "&thumbSize=" +
            window.filmstripSize +
            "&ival=" +
            window.filmstripInterval +
            "&end=visual&text=ffffff&bg=000000";
    });
}

$(".dashboard").on("click", ".chart__help", function (e) {
    reportFunctionUsage("onClick(.dashboard .chart__help)");
    e.preventDefault();
    // we only want to fire the event when people open the help, so check it's hidden
    if ($(this).closest(".chartwrapper").find(".chart__desc").is(":hidden")) {
        window.createEventForUser({
            name: "chart help",
            action: "view",
            info: $(this).closest(".chart__header").find(".chart__header-title").text(),
            type: "help",
        });
    }
    $(this).closest(".chartwrapper").find(".chart__desc").slideToggle(200);
});

$(".dashboard").on("click", ".metrictable__more-btn", function () {
    reportFunctionUsage("onClick(.dashboard .metrictable__more-btn)");
    const rows = $(this).parent().parent().find(".metrictable tr");
    if (this.textContent === "Show More") {
        this.textContent = "Show Less";
        rows.each(function () {
            this.style.display = "table-row";
        });
    } else {
        this.textContent = "Show More";
        let rowNum = 0;
        rows.each(function () {
            if (rowNum > 10) {
                this.style.display = "none";
            }
            rowNum++;
        });
    }
});

window.theme_color = "dark";
//Check to see what the current state of the theme is within the cookie.
if (document.cookie) {
    const themeCookie = document.cookie.split("; ").find((row) => row.startsWith("theme="));
    if (themeCookie) {
        const themeCookieVal = themeCookie.split("=")[1];
        if (themeCookieVal === "dark") {
            window.theme_color = "dark";
            if (document.contains(document.getElementById("theme-toggle"))) {
                document.getElementById("theme-toggle").checked = true;
            }
        } else {
            window.theme_color = "light";
        }
    } else {
        //No cookie set currently. So create one with the defaults.
        if (document.contains(document.getElementById("theme-toggle"))) {
            document.getElementById("theme-toggle").checked = true;
        }
        document.cookie = "theme=" + window.theme_color + "; path=/; max-age=2592000";
    }
}

$(".dashboard").on("click", ".dashboard__dropdown-theme", function (e) {
    e.preventDefault();
    toggleTheme();
});

function toggleTheme() {
    var theme_color = "dark";
    if (window.bThemeColor) {
        // switch to light
        theme_color = "light";
        document.getElementById("theme-toggle").checked = false;
        window.theme_color = "light";
        $("body").addClass("theme-light");
    } else {
        // switch to dark
        document.getElementById("theme-toggle").checked = true;
        $("body").removeClass("theme-light");
        window.theme_color = "dark";
    }
    window.bThemeColor = !window.bThemeColor;
    document.cookie = "theme=" + theme_color + "; path=/; max-age=2592000";
}

$(".dashboard__dropdown-share").click(function () {
    var share_prefix = "?";
    if (window.location.href.search(/\?/) > 0) {
        share_prefix = "&";
    }
    $("#share-input").val(window.location.href + share_prefix + "share=" + window.share);
    $("#share-link").text(window.location.href + share_prefix + "share=" + window.share);
    $("#share").slideToggle(200);
});

$("#share-copy").click(function () {
    window.copyToClipboard("#share-link");
    $("#share-input").fadeOut(100).fadeIn(100).fadeOut(100).fadeIn(100);
});

$("#snippet-copy").click(function () {
    window.copyToClipboard("#lux-snippet");
    $("#lux-snippet").fadeOut(100).fadeIn(100).fadeOut(100).fadeIn(100);
});

$(".dashboard__dropdown-fav, .dashboard-edit-close").click(function (e) {
    e.preventDefault();
    $("#edit-dashboard").slideToggle(200);
});

//If this is the first of the two item's they want to compare then add it to session storage. If it's the second go straight to the compare view and display results.
$("body").on("click", ".view-sessions__action", function () {
    reportFunctionUsage("onClick(.view-sessions__action)");
    if (window.Intercom) {
        window.Intercom("trackEvent", "sessions-from-chart");
    }
});

//If this is the first of the two item's they want to compare then add it to session storage. If it's the second go straight to the compare view and display results.
$("body").on("click", (e) => {
    if (e.target.classList.contains("compare__action")) {
        e.preventDefault();
        const action = e.target.getAttribute("data-action");
        const wpt_id = e.target.getAttribute("data-wpt_id");
        if (action === "add") {
            //Check the session storage to see if we already have a compare item in it.
            const compareItem = window.sessionStorage.getItem("compareSyntheticTest");
            if (compareItem !== null && compareItem !== wpt_id) {
                //we found a test in session storage.
                const compare_tests = [];
                compare_tests.push(compareItem);
                compare_tests.push(wpt_id);
                //Remember to remove the item from session storage before going to the compare view. So it's reset for next time.
                window.sessionStorage.removeItem("compareSyntheticTest");
                $("body").removeClass("compare-notification");
                window.location.href = window.accountUrl + "/compare/?tests=" + compare_tests.join(",");
            } else {
                //no test found, must be the first test they want to compare. Add to session storage.
                window.sessionStorage.setItem("compareSyntheticTest", wpt_id);
                $("body").addClass("compare-notification");
            }
        }
        if (action === "cancel") {
            //Remove the item from session storage and remove the notification.
            window.sessionStorage.removeItem("compareSyntheticTest");
            $("body").removeClass("compare-notification");
        }
    }
    if (e.target.classList.contains("bookmark__action")) {
        e.preventDefault();
        const action = e.target.getAttribute("data-action");
        const type = e.target.getAttribute("data-bookmark-type");
        const name = e.target.getAttribute("data-name");
        const description = e.target.getAttribute("data-description");
        const user_id = e.target.getAttribute("data-user-id");
        const href = e.target.href;
        if (action === "add") {
            $("#bookmark__href").val(href);
            $("#bookmark__bookmark-type").val(type);
            $("#bookmark__name").val("");
            $("#bookmark__description").val("");
            $("#bookmark__action").val("add");
            $(".bookmark__modal-name").html("<i class='icon-bookmark'></i> Add Bookmark");
            $("#new-bookmark-save").html("Add").removeAttr("disabled");
            $("#chartpop").hide();
            $("#add-bookmark")
                .modal("show")
                .on("shown.bs.modal", function () {
                    $("#bookmark__name").focus();
                });
            // auto save
            window.updateBookmark(type, href, "auto");
        }
        if (action === "edit") {
            $("#bookmark__href").val(href);
            $("#bookmark__bookmark-type").val(type);
            if (name) {
                $("#bookmark__name").val(name);
            }
            if (description) {
                $("#bookmark__description").val(description);
            }
            if (user_id === "") {
                $("#bookmark__personal").prop("checked", false);
                $("#bookmark__team").prop("checked", true);
            }
            $("#bookmark__action").val("edit");
            $(".bookmark__modal-name").html("<i class='icon-bookmark'></i> Edit Bookmark");
            $("#new-bookmark-save").html("Save").removeAttr("disabled");
            $("#add-bookmark")
                .modal("show")
                .on("shown.bs.modal", function () {
                    $("#bookmark__name").focus();
                });
        }
        if (action === "remove" || action === "remove-test" || action === "remove-session") {
            if (action === "remove") {
                $(this).parent().parent().css("opacity", "0.5");
            }
            window.updateBookmark(type, href, action);
        }
    }
});

//Check to see if we should be showing the compare notification on page load.
const compareItem = window.sessionStorage.getItem("compareSyntheticTest");
if (compareItem !== null) {
    $("body").addClass("compare-notification");
}

const compareSessionStorageKey = makeLocalStorageKey("rum-compare-sessions");
const compareSession = window.sessionStorage.getItem(compareSessionStorageKey);
if (compareSession) {
    $("body").addClass("compare-rum-notification");
}

//If this is the first of the two item's they want to compare then add it to session storage. If it's the second go straight to the compare view and display results.
$("body").on("click", (e) => {
    if (e.target.classList.contains("compare__rum__action")) {
        e.preventDefault();
        if (e.target.getAttribute("data-action") === "cancel") {
            //Remove the item from session storage and remove the notification.
            window.sessionStorage.removeItem(compareSessionStorageKey);
            $("body").removeClass("compare-rum-notification");
        }
    }
});

$("body").on("click", "#new-bookmark-save", function (e) {
    e.preventDefault();
    $(this).html("Saving").attr("disabled", "disabled");
    window.updateBookmark(
        $("#bookmark__bookmark-type").val(),
        $("#bookmark__href").val(),
        $("#bookmark__action").val(),
        $("#bookmark__name").val(),
        $("#bookmark__description").val(),
        $("#bookmark__team").is(":checked"),
        $("#bookmark__version").val(),
    );
});

$("body").on("click", "#new-bookmark-remove", function (e) {
    e.preventDefault();
    if ($("#bookmark__wpt_id").val()) {
        window.updateBookmark("syn", $("#bookmark__href").val(), "remove");
    }
    if ($("#bookmark__rum-params").val()) {
        window.updateBookmark("rum", $("#bookmark__href").val(), "remove");
    }
});

window.updateBookmark = function (bookmark_type, href, action, name, description, shared, version) {
    $.ajax({
        type: "POST",
        url: href,
        data: {
            bookmark_type: bookmark_type,
            action: action,
            name: name,
            description: description,
            shared: shared,
            version: version,
        },
        dataType: "json",
        context: $(this),
        error: function (error) {
            console.error("Bookmark save failed: ", error);
        },
        success: function (data) {
            if (data.status === "added" || data.status === "updated") {
                $(".compare__button").html("Remove Bookmark").data("action", "remove");
                $(".bookmark__link")
                    .html("<i class='icon-bookmark'></i> Remove Bookmark")
                    .attr("data-bookmark_id", data.bookmark_id)
                    .attr("data-action", "remove");
                $(".bookmark__test")
                    .html("<i class='icon-bookmark'></i> Remove Bookmark")
                    .attr(
                        "href",
                        window.accountUrl + "/bookmarks/?bookmark_id=" + data.bookmark_id + "&wpt_id=" + data.wpt_id,
                    )
                    .attr("data-bookmark_id", data.bookmark_id)
                    .attr("data-action", "remove-test");
                $(".bookmark__edit")
                    .html("<i class='icon-pencil'></i> Edit Bookmark&nbsp;&nbsp;")
                    .attr(
                        "href",
                        window.accountUrl + "/bookmarks/?bookmark_id=" + data.bookmark_id + "&wpt_id=" + data.wpt_id,
                    )
                    .attr("data-name", data.name)
                    .attr("data-description", data.description);
                let name_space = "&nbsp;&nbsp;";
                if (data.name === null) {
                    data.name = "";
                }
                if (data.name === "") {
                    name_space = "";
                }
                if (data.description === null || data.description === "") {
                    $(".bookmark__description-wrapper" + data.version).html("");
                } else {
                    $(".bookmark__description-wrapper" + data.version).html(
                        "<p class='bookmark__description" +
                            data.version +
                            "' style='margin-bottom: 0'>" +
                            data.description +
                            "</p>",
                    );
                }
                $(".bookmark__name-wrapper" + data.version).html(
                    "<span class='bookmark__name" + data.version + "'>" + data.name + "</span>" + name_space,
                );
            }
            if (data.status === "removed") {
                // check if the bookmark_id removed matches the dashboard we are on.
                if (
                    $(".bookmark__test").data("bookmark_id") === data.bookmark_id ||
                    data.action === "remove-test" ||
                    data.action === "remove-session"
                ) {
                    $(".bookmark__test").html("<i class='icon-bookmark'></i> Add Bookmark").attr("data-action", "add");
                    $(".bookmark__name-wrapper").html("");
                    $(".bookmark__description-wrapper").html("");
                    $(".bookmark__edit").html("");
                }
            }
            if (data.action === "auto") {
                if ($("#bookmark__name").val() === "") {
                    //$('#bookmark__name').val(data.meta);
                }
            } else {
                $("#add-bookmark").modal("hide");
            }
            $(".bookmarks_content").html(data.html);
        },
    });
};

$(".bookmarks_content").on("click", ".compare__compare", function (e) {
    e.preventDefault();
    const compare_tests = [];
    $.each($("input[name='compare-test']:checked"), function () {
        compare_tests.push($(this).val());
    });
    if (compare_tests.length === 2) {
        // reverse the order so the most recent is last
        const compare_tests_rev = compare_tests.reverse();
        window.location.href = window.accountUrl + "/compare/?tests=" + compare_tests_rev.join(",");
    } else {
        $(".compare__warning").html("Select two tests thanks!");
    }
});

$(".dashboard").on("click", ".dashboard__dropdown-trends", function (e) {
    e.preventDefault();
    window.toggleTrend();
    location.reload();
});

$("#charts, .charts").on("click", ".chart__dropdown-csv", function (e) {
    reportFunctionUsage("onClick(#charts .chart__dropdown-csv)");
    var title = $(this).closest(".chart__header").find(".chart__header-title").text().toLowerCase();
    var $container = $(this).closest(".chartwrapper").find(".chart__content div[data-highcharts-chart]");
    var chart = $container.highcharts();
    if (chart) {
        $(this).attr({
            download: title + ".csv",
            href: "data:text/csv;charset=utf-8," + encodeURIComponent(chart.getCSV()),
        });
    } else {
        e.preventDefault();
    }
});

$("#charts, .charts").on("click", ".chart__dropdown-image", function (e) {
    reportFunctionUsage("onClick(#charts .chart__dropdown-image)");
    e.preventDefault();
    var title = $(this).closest(".chart__header").find(".chart__header-title").text().toLowerCase();
    var $container = $(this).closest(".chartwrapper").find(".chart__content div[data-highcharts-chart]");
    var chart = $container.highcharts();
    var plotLines = chart.options.xAxis[0].plotLines;
    var newY = chart.options.yAxis.slice(0);
    for (let i = 0; i < newY.length; i++) {
        newY[i].labels.style.color = "#7f7f7f";
        newY[i].gridLineColor = "#7f7f7f";
        newY[i].gridLineDashStyle = "dot";
        if (typeof newY[i].title.style !== "undefined") {
            newY[i].title.style.color = "#7f7f7f";
        }
    }
    var newX = chart.options.xAxis.slice(0);
    for (let i = 0; i < newX.length; i++) {
        newX[i].labels.style.color = "#7f7f7f";
    }
    newX[0].plotLines = plotLines;
    if (chart) {
        chart.exportChartLocal(
            { filename: title },
            {
                xAxis: newX,
                yAxis: newY,
                legend: {
                    itemStyle: {
                        color: "#7F7F7F",
                    },
                },
            },
        );
    }
});

window.numberWithCommas = function numberWithCommas(x) {
    reportFunctionUsage("numberWithCommas");
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

function lsTest() {
    reportFunctionUsage("lsTest");
    var test = "test";
    try {
        localStorage.setItem(test, test);
        localStorage.removeItem(test);
        return true;
    } catch (e) {
        return false;
    }
}

$(document).ready(function () {
    $(".tags").select2({
        theme: "bootstrap",
        tags: true,
        minimumResultsForSearch: 10,
    });
    $(".select2-single").select2({
        theme: "bootstrap",
        minimumResultsForSearch: 10,
    });
    $(".select2-single--testnow").select2({
        theme: "bootstrap",
        minimumResultsForSearch: 10,
        dropdownParent: $("#testnow"),
    });
    $(".select2-single-tag").select2({
        theme: "bootstrap",
        tags: true,
        placeholder: "",
        allowClear: true,
        minimumResultsForSearch: 10,
    });
    $(".select2-single-tag-with-search").select2({
        theme: "bootstrap",
        tags: true,
        placeholder: "",
        allowClear: true,
    });
});

/*** settings -> sites table **/
// hide paused sites if total rows number > N
const maxRowsNum = 30;
$("#sites").each(function () {
    const $table = $(this);
    const totalRows = $table.find("tbody tr").length;
    const pausedRows = $table.find("tbody tr.paused").length;
    if (totalRows > maxRowsNum && pausedRows > 0 && totalRows !== pausedRows) {
        $table.find("tbody tr.paused").each(function () {
            $(this).addClass("hidden");
        });

        const colspan = $table.find("th").length;
        $(
            '<tr><td colspan="' +
                colspan +
                '" align="center" style="cursor:pointer;">Show ' +
                pausedRows +
                " paused sites</td></tr>",
        )
            .appendTo($table.find("tbody"))
            .click(function () {
                $table.find("tbody tr.hidden").each(function () {
                    const $row = $(this);
                    $row.removeClass("hidden");
                });
                $(this).remove();
            });
    }
});

$("#sites").on("click keypress", ".testnow", function () {
    reportFunctionUsage("onClick(#sites .testnow)");
    const siteId = $(this).data("site-id");
    window.selected_site_id = siteId;
    $("#test-now-mount-point button").click();
});

// setup request idle callback or request animation frame to handle async work while processing all the charts or other long JS tasks
window.doAsyncWork =
    typeof window.requestIdleCallback === "function" ? window.requestIdleCallback : window.requestAnimationFrame;

performance.measure("dashboardjs eval", "dashboardjs before");
